import { OrganizationRoles } from 'src/enums'
import {
  BookkeeperAccountVisibility,
  OrganizationsListModel,
} from 'src/models/organizations.models'
import { PaginationResponse } from 'src/models/pagination.models'
import { UserListModel, UserListResponse } from 'src/models/user.models'

export interface UserConnectionResponse {
  id: string
  createdAt: string
  reason: string
  userTo: UserListModel
}

export class UserConnectionModel {
  public id: string
  public createdAt: string
  public reason: string
  public userTo: UserListModel

  public constructor(data: UserConnectionResponse) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.reason = data.reason
    this.userTo = new UserListModel(data.userTo)
  }
}

export interface PeopleContactsResponse {
  pagination: PaginationResponse
  userConnections: UserConnectionResponse[]
}

export class PeopleContactsModel {
  public pagination: PaginationResponse
  public userConnections: UserConnectionResponse[]

  public constructor(data: PeopleContactsResponse) {
    this.pagination = data.pagination
    this.userConnections = data.userConnections
  }
}

export interface PeopleMembersResponse {
  pagination: PaginationResponse
  users: UserListModel[]
}

export class PeopleMembersModel {
  public pagination: PaginationResponse
  public users: UserListResponse[]

  public constructor(data: PeopleMembersResponse) {
    this.pagination = data.pagination
    this.users = data.users
  }
}

export enum OrgInviteStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED',
}

export interface OrgInviteResponse {
  id: string
  organization: OrganizationsListModel
  inviter: UserListModel
  invitee: UserListModel
  status: OrgInviteStatus
  createdAt: string
  role: OrganizationRoles
  accountVisibility?: BookkeeperAccountVisibility
}

export class OrgInviteModel {
  public id: string
  public organization: OrganizationsListModel
  public inviter: UserListModel
  public invitee: UserListModel
  public status: OrgInviteStatus
  public createdAt: string
  public role: OrganizationRoles
  public accountVisibility?: BookkeeperAccountVisibility

  public constructor(data: OrgInviteResponse) {
    this.id = data.id
    this.organization = new OrganizationsListModel(data.organization)
    this.inviter = new UserListModel(data.inviter)
    this.invitee = new UserListModel(data.invitee)
    this.status = data.status
    this.createdAt = data.createdAt
    this.role = data.role
    this.accountVisibility = data.accountVisibility
  }
}

export interface PeopleInvitedToOrgResponse {
  pagination: PaginationResponse
  organizationInvites: OrgInviteResponse[]
}

export class PeopleInvitedToOrgModel {
  public pagination: PaginationResponse
  public organizationInvites: OrgInviteResponse[]

  public constructor(data: PeopleInvitedToOrgResponse) {
    this.pagination = data.pagination
    this.organizationInvites = data.organizationInvites
  }
}
